import styled from "styled-components"

// NOTE - these different vendor prefixes / values are intentional,
// to override default styles on desktop and iOS Safari
export const NumberInputElement = styled.input.attrs({ type: "number" })`
  -webkit-appearance: none;
  -moz-appearance: textfield;
  border-style: solid;
  border-color: ${(props) => props.theme.input.borderColor};
  border-width: ${(props) => props.theme.input.borderWidth} 0;
  border-radius: 0px;
  font-size: ${(props) => props.theme.input.textSize};
  line-height: 1;
  width: 50px;
  color: ${(props) => props.theme.input.textColor};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  background-color: ${(props) => props.theme.input.background};
  font-family: ${(props) => props.theme.font.primary};

  &:active,
  :focus {
    outline: none;
    border-color: ${(props) => props.theme.input.borderActive};
    outline-offset: -1px;
  }

  &:disabled {
    opacity: 0.5;
  }

  &::-webkit-inner-spin-button,
  &::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const NumberInputButton = styled.button.attrs({ type: "button" })`
  padding: 0 16px;
  font-size: ${(props) => props.theme.input.textSize};
  height: 100%;
  width: 40px;
  color: ${(props) => props.theme.input.textColor};
  display: flex;
  align-items: center;
  justify-content: center;
  border-style: solid;
  text-align: center;
  border-width: ${(props) => props.theme.input.borderWidth};
  border-color: ${(props) => props.theme.input.borderColor};
  user-select: none;
  background-color: ${(props) => props.theme.input.background};

  &:first-of-type {
    border-radius: ${(props) =>
      `${props.theme.input.borderRadius} 0 0 ${props.theme.input.borderRadius}`};
  }

  &:last-of-type {
    border-radius: ${(props) =>
      `0 ${props.theme.input.borderRadius} ${props.theme.input.borderRadius} 0`};
  }

  &:focus,
  &:active {
    outline: none;
    border-color: ${(props) => props.theme.input.borderFocus};
  }

  &:disabled {
    opacity: 0.5;
    pointer-events: none;
    cursor: default;
  }
`
